import { ObservacionModalForm } from "./ObservacionModalForm"


const ObservacionModalFormWrapper = () => {
    return (<ObservacionModalForm />)
}

export {ObservacionModalFormWrapper}